module.exports = __webpack_public_path__ + "static/media/logo.c1352b3b.png";